<template>
  <ten-popup
    v-bind="popupProps"
    :show="isShow"
    @change="onShowChangeHandler"
  >
    <template v-slot:trigger>
      <!-- @slot 触发下拉列表显示的元素。 注意： 必须是一个元素或者或者组件 -->
      <slot />
    </template>

    <!-- @slot 下拉列表，通常是 <ten-dropdown-menu> 组件 -->
    <slot name="dropdown" />
  </ten-popup>
</template>

<script>
import Popup from '../popup';

const name = 'ten-dropdown';
export default {
  name,
  components: {
    TenPopup: Popup,
  },
  inheritAttrs: false,
  provide() {
    return {
      tenDropdown: this,
    };
  },
  props: {
    /**
     * 是否显示下拉框
     */
    show: Boolean,
    /**
     * 选项点击后是否隐藏 dropdown
     */
    hideAfterItemClick: { type: Boolean, default: true },
  },
  data() {
    return {
      isShow: this.show,
    };
  },
  computed: {
    popupProps() {
      const { direction, width, type = 'default', destroy = true, offset, disabled = false } = this.$attrs;
      let triggerType;
      let popupClass;
      // eslint-disable-next-line
      if (this.$attrs.triggerType) triggerType = this.$attrs.triggerType;
      if (this.$attrs['trigger-type']) triggerType = this.$attrs['trigger-type'];
      // eslint-disable-next-line
      if (this.$attrs.popupClass) popupClass = this.$attrs.popupClass;
      if (this.$attrs['popup-class']) popupClass = this.$attrs['popup-class'];

      const props = {
        type,
        destroy,
        offset,
        disabled,
        width,
        triggerType: triggerType || 'click',
        popupClass: `${popupClass || ''} ten-dropdown`,
        direction: direction || 'bottom center',
      };
      return props;
    },
    triggerType() {
      return this.$attrs.triggerType || this.$attrs['trigger-type'];
    },
  },
  watch: {
    show(val) {
      if (this.triggerType === 'manual') {
        this.isShow = val;
      }
    },
  },
  created() {
    this.$on('dropdown-item:click', this.onDropDownItemClick);
  },
  methods: {
    popupWidthHanlder(trigger) {
      return trigger.offsetWidth;
    },
    onShowChangeHandler(visible) {
      if (this.triggerType !== 'manual') {
        this.isShow = visible;
      }
      this.$emit('change', visible);
    },
    onDropDownItemClick(index) {
      if (this.hideAfterItemClick && this.triggerType !== 'manual') {
        this.isShow = false;
        this.$emit('change', false);
      }
      /**
       * item点击回调
       * @param {Number} index 被点击item的index
       */
      this.$emit('item-click', index);
    },
  },
};
</script>
